var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model.htmlBody)?_c('div',{directives:[{name:"epi-edit",rawName:"v-epi-edit",value:('HtmlBody'),expression:"'HtmlBody'"}],domProps:{"innerHTML":_vm._s(_vm.model.htmlBody)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }